import { ExportToCsv } from 'export-to-csv';

function toExportRows(columns, records) {
    const headers = (Array.isArray(columns) ? columns : []).map((column) => String(column ?? ''));
    const rows = Array.isArray(records) ? records.filter((row) => row != null) : [];
    const keys = rows[0] && typeof rows[0] === 'object' && !Array.isArray(rows[0])
        ? Object.keys(rows[0])
        : [];

    const exportRows = rows.map((row) => {
        const out = {};
        headers.forEach((header, index) => {
            if (Array.isArray(row)) {
                out[header] = row[index] ?? '';
                return;
            }
            if (row && Object.prototype.hasOwnProperty.call(row, header)) {
                out[header] = row[header] ?? '';
                return;
            }
            const key = keys[index];
            out[header] = key != null ? (row?.[key] ?? '') : '';
        });
        return out;
    });

    if (exportRows.length > 0) {
        return { headers, exportRows };
    }

    const emptyRow = {};
    headers.forEach((header) => {
        emptyRow[header] = '';
    });
    return { headers, exportRows: headers.length ? [emptyRow] : [{ Export: '' }] };
}

export function exportAsCSV(columns, records, filename = 'export') {
    const { headers, exportRows } = toExportRows(columns, records);
    const csvExporter = new ExportToCsv({
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers,
        filename,
    });

    csvExporter.generateCsv(exportRows);
}
